<template>
  <v-row dense>
    <v-col class="text-h6">
      <v-row>
        <v-col> Design Groups </v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-btn
            color="primary"
            :loading="saving"
            @click="save"
          >
            Save Design Groups
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-treeview
          v-model="selected"
          selection-type="leaf"
          selectable
          selected-color="primary"
          :items="items"
        />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  name: 'CategoryDesignGroupTree',

  data() {
    return {
      selected: [],
      saving: false
    };
  },
  computed: {
    items() {
      const typeId =
        this.category.name === 'Card'
          ? this.$enums.INDUSTRY_TYPE.PURPOSE
          : this.$enums.INDUSTRY_TYPE.BUSINESS;
      return this.industries
        .filter((x) => x.typeId === typeId)
        .map((x) => ({
          id: `industry|${x.id}`,
          name: x.name,
          children: this.getTopics(x).concat(this.getDesignGroups(x))
        }))
        .filter((x) => x.children.length);
    },
    designGroupIds() {
      return (this.category.designGroupIds || []).map((x) => `designgroup|${x}`);
    },
    ...mapGetters({
      category: 'categories/category',
      industries: 'lookup/industries',
      // Retired topics aren't places to attach a category's design groups.
      topics: 'lookup/activeTopics',
      design_groups: 'lookup/design_groups'
    })
  },
  watch: {
    designGroupIds(val, oldVal) {
      if (val !== oldVal) {
        this.setSelected();
      }
    },
    items(val, oldVal) {
      if (val !== oldVal) {
        this.setSelected();
      }
    }
  },
  mounted() {
    this.setSelected();
  },
  methods: {
    setSelected() {
      this.selected = cloneDeep(this.designGroupIds);
    },
    getTopics(industry) {
      return this.topics
        .filter((x) => x.industryId === industry.id)
        .map((x) => ({
          id: `topic|${x.id}`,
          name: x.name.replace(`${industry.name} > `, ''),
          children: this.getDesignGroups(industry, x)
        }))
        .filter((x) => x.children.length);
    },
    getDesignGroups(industry, topic) {
      if (topic) {
        return this.design_groups
          .filter((x) => x.topicId === topic.id)
          .map((x) => ({
            id: `designgroup|${x.id}`,
            name: x.name.replace(`${topic.name} >`, '')
          }));
      } else if (industry) {
        return this.design_groups
          .filter((x) => x.industryId === industry.id && !x.topicId)
          .map((x) => ({
            id: `designgroup|${x.id}`,
            name: x.name.replace(`${industry.name} >`, '')
          }));
      }
      return [];
    },
    save() {
      this.saving = true;
      this.$store
        .dispatch('categories/saveDesignGroups', {
          categoryId: this.category.id,
          designGroupIds: this.selected.map((x) => x.replace('designgroup|', ''))
        })
        .then(() => {
          this.$root.$snackbarSuccess('Category Design Groups saved');
          this.$emit('save');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
